function formatRecoveryFlaggedAt(iso) {
  if (iso == null || iso === "") return "—";
  try {
    const d = new Date(iso);
    if (Number.isNaN(d.getTime())) return String(iso);
    const ms = Date.now() - d.getTime();
    if (ms < 0) {
      return d.toLocaleString("en-IN", { timeZone: "Asia/Kolkata" }) + " IST";
    }
    const sec = Math.floor(ms / 1000);
    const min = Math.floor(sec / 60);
    const hr = Math.floor(min / 60);
    const day = Math.floor(hr / 24);
    const abs = d.toLocaleString("en-IN", {
      timeZone: "Asia/Kolkata",
      dateStyle: "medium",
      timeStyle: "short",
    });
    if (day > 0) return `Flagged ${day} day(s) ago · ${abs} IST`;
    if (hr > 0) return `Flagged ${hr} hour(s) ago · ${abs} IST`;
    if (min > 0) return `Flagged ${min} minute(s) ago · ${abs} IST`;
    return `Just now · ${abs} IST`;
  } catch {
    return String(iso);
  }
}

function isWebhookRecoveryReason(reason) {
  const r = String(reason || "");
  const lower = r.toLowerCase();
  return (
    lower.includes("payment gateway reported") ||
    lower.includes("reconciliation found")
  );
}

/**
 * @param {object} props
 * @param {string|null|undefined} props.reason
 * @param {string|null|undefined} props.flaggedAt — ISO timestamp from `refund_recovery_set_at`
 * @param {() => void} props.onRetry
 * @param {boolean} props.retryLoading
 * @param {() => void|Promise<void>} [props.onRefresh] — re-fetch ticket detail only; does not retry refund
 * @param {boolean} [props.refreshLoading]
 */
export default function RecoveryBanner({
  reason,
  flaggedAt,
  onRetry,
  retryLoading,
  onRefresh,
  refreshLoading = false,
}) {
  return (
    <div
      className="mb-6 rounded-2xl border border-red-300 bg-red-50 px-4 py-4 text-red-900 shadow-sm"
      role="alert"
    >
      <div className="flex flex-col gap-4 sm:flex-row sm:items-start sm:justify-between">
        <div className="flex min-w-0 gap-3">
          <span className="text-2xl shrink-0" aria-hidden>
            ⚠️
          </span>
          <div className="min-w-0">
            <div className="text-base font-bold tracking-tight">Refund needs follow-up</div>
            {reason ? (
              <div className="mt-2 flex min-w-0 flex-col gap-2 sm:flex-row sm:items-start sm:gap-3">
                {isWebhookRecoveryReason(reason) ? (
                  <span className="shrink-0 rounded-full bg-amber-100 px-2 py-0.5 text-xs font-semibold text-amber-800">
                    System detected
                  </span>
                ) : null}
                <p className="min-w-0 flex-1 text-sm leading-relaxed whitespace-pre-wrap break-words">
                  {reason}
                </p>
              </div>
            ) : (
              <p className="mt-2 text-sm text-red-800/80 italic">No reason recorded.</p>
            )}
            <p className="mt-2 text-xs font-medium text-red-800/90">
              {formatRecoveryFlaggedAt(flaggedAt)}
            </p>
          </div>
        </div>
        <div className="flex shrink-0 flex-col gap-2 sm:flex-row sm:items-start sm:pt-0.5">
          <button
            type="button"
            onClick={onRetry}
            disabled={retryLoading}
            className="bg-red-700 hover:bg-red-800 text-white rounded-xl px-4 py-2 text-sm font-semibold disabled:opacity-50 w-full sm:w-auto"
          >
            {retryLoading ? "Retrying..." : "Retry Failed Refund"}
          </button>
          {typeof onRefresh === "function" ? (
            <button
              type="button"
              onClick={onRefresh}
              disabled={refreshLoading || retryLoading}
              className="w-full rounded-xl border border-red-300 bg-white px-3 py-2 text-xs font-semibold text-red-700 hover:bg-red-50 disabled:opacity-50 sm:w-auto"
            >
              {refreshLoading ? "Refreshing…" : "Refresh"}
            </button>
          ) : null}
        </div>
      </div>
    </div>
  );
}
